"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var adzerkHeaderBiddingUnitMap_1 = require("../config/adzerkHeaderBiddingUnitMap");
var getAdSize_1 = __importDefault(require("./getAdSize"));
var getHardcodedAdString_1 = __importDefault(require("./getHardcodedAdString"));
var getHeaderBiddingInlineStyle_1 = __importDefault(require("./getHeaderBiddingInlineStyle"));
var getPlacementSizes_1 = require("./getPlacementSizes");
/**
 * extracted from utilities - generateAndRenderHardcodedCreative 2127
 * file is fine; in sync with prod.
 */
function generateAndRenderHardcodedCreative(divId) {
    var placementName = divId.split("-")[0];
    var adzerkUnitMeta = adzerkHeaderBiddingUnitMap_1.adzerkHeaderBiddingUnitMap[placementName];
    var element = document.getElementById(divId);
    var sizes = (0, getPlacementSizes_1.getPlacementSizes)(placementName);
    if (!adzerkUnitMeta || !element || !sizes) {
        return;
    }
    var inlineStyle = (0, getHeaderBiddingInlineStyle_1.default)(sizes);
    var size = (0, getAdSize_1.default)(sizes);
    if (size) {
        var width = size[0], height = size[1];
        var creative = (0, getHardcodedAdString_1.default)(placementName, {
            width: width,
            height: height,
            inlineStyle: inlineStyle,
        });
        element.innerHTML = creative;
    }
}
exports.default = generateAndRenderHardcodedCreative;
